// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/allflamenco-theme.scss
// module id = 89
// module chunks = 0